import React from 'react'
import { SortDescriptor } from '@progress/kendo-data-query/dist/npm/sort-descriptor'
import { MarketingCampaignDetailDto } from 'api/Trading-Accounts/Types/MarketingCampaignDetailDto'

import { CampaignDetailsResultsPage } from './CampaignDetailsResultsPage'
import campaignRebateDetailsResultsColumn from './campaignRebateDetailsResultsColumn'

interface OuterProps {
  data: MarketingCampaignDetailDto
}

const sortQuery: SortDescriptor[] = []

export const CampaignRebateDetailsResultsPage: React.FC<OuterProps> = ({ data }) => {
  return (
    <CampaignDetailsResultsPage
      data={data}
      columns={campaignRebateDetailsResultsColumn}
      sortQuery={sortQuery}
    />
  )
}
